import styled from "styled-components";
import { ArrowScroll } from "../../../services/visualLibraryService";
import { detailBackgroundStyled } from "../../../styles/shared-styles";

export const DetailPageStyled = styled.section`
  padding: ${props => props.theme.baseLayoutPaddingBs}% 0;
  ${detailBackgroundStyled.styles};
`;

export const ArrowScrollStyled = styled(ArrowScroll)`
  margin: 0 auto;
`;
